import Vue from 'vue'
import Hammer from 'hammerjs'

Vue.directive('touch', {

  bind: (el, binding) => {
    const event = binding.arg
    // const options = el.hammerOptions

    if (!el.hammer) el.hammer = new Hammer(el)
    if (!event) { console.warn('[vue-touch] event type argument is required.'); return }
    // if (events.indexOf(event) === -1) { console.warn('[vue-touch] event type argument is invalid.'); return }

    el.hammer.get('swipe').set({ direction: Hammer.DIRECTION_ALL })

    // if (options) el.hammer.set(options)

    el.hammer.on(event, binding.value)
  },

  unbind: (el) => {
    if (el.hammer) {
      el.hammer.destroy()
      el.hammer = null
    }
  }

})

// Vue.directive('touch-options', {

//   update: (el, binding) => {
//     if (!binding.value) { console.warn('[vue-touch-options] value is required.'); return }

//     el.hammerOptions = binding.value
//   }

// })



// WEBPACK FOOTER //
// ./src/services/v-touch.js